






















































import Vue from 'vue'
import { CAROUSEL_ITEM_LIMIT } from '@/product/const'

const BREAKPOINT_DOWN_SM = 600

export default Vue.extend({
  components:{
  },
  props: {
    headerTitle: {
      type: String,
      required: true
    },
    listItems: {
      type: Array,
      required: true
    },
    itemTotalCount: {
      type: Number,
      required: true
    },
    hideDisplayPage: {
      type: Boolean,
      default: false
    }
  },
  data(): {
    itemLimit: number
    currentPage: number
    slideClass: string
    touchPoint: {
      start: number
      end: number
    }
  } {
    return {
      itemLimit: CAROUSEL_ITEM_LIMIT,
      currentPage: 1,
      slideClass: 'slide-out',
      touchPoint: {
        start: 0,
        end: 0
      }
    }
  },
  computed: {
    disablePrev(): boolean {
      return this.currentPage == 1
    },
    disableNext(): boolean {
      return this.currentPage == this.itemTotalPage
    },
    itemTotalPage(): number{
      return this.itemTotalCount < this.itemLimit ? 1 : Math.ceil(this.itemTotalCount / this.itemLimit)
    }
  },
  mounted() {
    if (window.innerWidth <= BREAKPOINT_DOWN_SM) {
      this.touchLeftHandler()
      this.touchRightHandler()
    }
  },
  methods: {
    back() {
      this.currentPage--
      this.slideClass = 'slide-in'
      this.fetchData()
    },
    next() {
      this.currentPage++
      this.slideClass = 'slide-out'
      this.fetchData()
    },
    fetchData() {
      const offset = (this.currentPage - 1) * this.itemLimit
      this.$emit('fetchData', {
        offset,
        limit: this.itemLimit
      })
    },
    touchLeftHandler() {
      const control = this.$el.getElementsByClassName('pr-Carousel_BodyItemsTouchArea-left')[0]
      let startX = 0, endX = 0
      control.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX
      })
      control.addEventListener('touchmove', e => {
        endX = e.touches[0].clientX
      })
      control.addEventListener('touchend', () => {
        if (startX < endX && !this.disablePrev) {
          this.back()
        }
      })
    },
    touchRightHandler() {
      const control = this.$el.getElementsByClassName('pr-Carousel_BodyItemsTouchArea-right')[0]
      let startX = 0, endX = 0
      control.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX
      })
      control.addEventListener('touchmove', e => {
        endX = e.touches[0].clientX
      })
      control.addEventListener('touchend', () => {
        console.log(startX, endX)
        if (startX > endX && !this.disableNext) {
          this.next()
        }
      })
    }
  }
})
